import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("amal_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch((err) => {
        // Only drop token on real auth failures (401). Keep it on offline / network errors.
        if (err.response?.status === 401) {
          localStorage.removeItem("amal_token");
        }
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (access_code) => {
    const { data } = await api.post("/auth/login", { access_code });
    localStorage.setItem("amal_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("amal_token");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

export const ROLE_LABELS = {
  admin: "Administrateur",
  president: "Président",
  tresorier: "Trésorier",
  secretaire: "Secrétaire",
  coach: "Entraîneur",
  rh: "Responsable RH",
  joueur: "Joueur",
  parent: "Parent",
  partenaire: "Partenaire",
};
